import React, { useState } from 'react';

interface SuccessCardProps {
  success: {
    Area: string;
    Success: string;
    ContinuedDevelopment: string;
  };
  index: number;
}

const SuccessCard: React.FC<SuccessCardProps> = ({ success, index }) => {
  const [isDevelopmentExpanded, setIsDevelopmentExpanded] = useState(false);
  
  const toggleDevelopment = () => {
    setIsDevelopmentExpanded(!isDevelopmentExpanded);
  };

  return (
    <div style={{
      background: 'rgb(245, 255, 245)',
      borderRadius: '6px',
      padding: '0.5rem',
      borderBottom: '1px solid #f7fafc',
      marginBottom: '1rem'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: '0.75rem'
      }}>
        <div style={{
          background: '#c6f6d5',
          borderRadius: '50%',
          width: '2rem',
          height: '2rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          marginTop: '0.125rem'
        }}>
          <span style={{ fontSize: '1rem', color: '#2f855a' }}>
            {index + 1}
          </span>
        </div>
        <div style={{ width: '100%' }}>
          {/* Area */}
          <div style={{
            fontWeight: '600',
            color: '#2f855a',
            fontSize: '1.1rem'
          }}>
            {success.Area}
          </div>
          
          {/* Success */}
          <div style={{
            color: '#2d3748'
          }}>
            {success.Success}
          </div>
          
          {/* Continued Development - Collapsible */}
          <div 
            onClick={toggleDevelopment}
            style={{
              display: 'flex',
              marginTop: '0.1rem',
              cursor: 'pointer',
              ...(isDevelopmentExpanded ? {
                padding: '0.75rem',
                borderRadius: '8px',
                flexDirection: 'column',
                alignItems: 'stretch'
              } : {
                padding: '0.25rem 0',
                alignItems: 'center'
              })
            }}
          >
            <div 
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%'
              }}
            >
              <span style={{
                fontWeight: '600', 
                color: '#38a169',
                fontSize: isDevelopmentExpanded ? '0.95rem' : '0.85rem',
                display: 'flex',
                alignItems: 'center'
              }}>
                {!isDevelopmentExpanded && (
                  <span style={{
                    display: 'inline-block',
                    width: '3px',
                    height: '1em',
                    background: '#38a169',
                    marginRight: '0.5rem',
                    borderRadius: '1px'
                  }}></span>
                )}
                How to Leverage This Success
              </span>
              <span style={{ 
                transform: isDevelopmentExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.2s ease',
                fontSize: '0.9rem',
                color: '#38a169',
                opacity: '0.8'
              }}>
                ▼
              </span>
            </div>
            
            {isDevelopmentExpanded && (
              <div style={{ 
                marginTop: '0.75rem',
                paddingTop: '0.75rem',
                borderTop: '1px solid rgba(56, 161, 105, 0.2)',
                fontSize: '0.75rem'
              }}>
                {success.ContinuedDevelopment}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessCard;
